import _                 from 'lodash'
import Immutable         from 'immutable'
import { NotFoundError } from 'lib/errors'

export default class EntitySpace
  constructor: (@maps) ->

  @for: (model, entities) ->
    map  = new Immutable.OrderedMap(entities.map (entity) -> [entity.pk, entity])
    maps = (new Immutable.Map).set(model, map)

    new @(maps)

  mapFor: (model) ->
    @maps.get(model) or throw new Error("no secondary map for #{model.name}")

  safeMapFor: (model) ->
    @maps.get(model) or new Immutable.OrderedMap

  mapForOrNull: (model) ->
    @maps.get(model)

  entityFor: (model, pk) ->
    @maps.getIn([model, pk]) or throw new NotFoundError(model)

  safeEntityFor: (model, pk) ->
    @maps.getIn([model, pk])

  merge: (other) ->
    new @constructor(@maps.mergeDeep(other.maps))

  add: (entity) ->
    new @constructor(@maps.setIn([entity.constructor, entity.pk], entity))

  update: (entity) ->
    new @constructor(@maps.setIn([entity.constructor, entity.pk], entity))

  remove: (entity) ->
    new @constructor(@maps.deleteIn([entity.constructor, entity.pk]))
